export type EndpointType = "layout-analysis" | "ocr" | "extractor";

// Endpoint별 코드 스니펫 언어 타입
export type CodeLanguage = "python" | "curl" | "nodejs" | "langchain";

export interface EndpointConfig {
  apiPath: string; // API 경로
  playgroundPath: string; // 플레이그라운드 경로
  documentationUrl: string; // 문서화 URL
  displayName: string; // 표시 이름
  showModel: boolean; // 모델 정보 표시 여부
  showConfig: boolean; // 설정 표시 여부
  showConfidenceScore: boolean; // 신뢰도 점수 여부
  // 코드 스니펫 관련 정보
  apiUrl: string; // 전체 API URL (code 예시에 사용)
  availableLanguages: CodeLanguage[]; // 해당 엔드포인트에서 사용 가능한 언어 목록
  defaultModelName: string; // 기본 모델 이름
}

export const ENDPOINT_CONFIGS: Record<EndpointType, EndpointConfig> = {
  "layout-analysis": {
    apiPath: "/api/layout-analysis",
    playgroundPath: "/playground/dp",
    documentationUrl:
      "https://console.upstage.ai/docs/capabilities/document-digitization/document-parsing",
    displayName: "Document parsing",
    showModel: false,
    showConfig: true,
    showConfidenceScore: false,
    apiUrl: "https://api.upstage.ai/v1/document-digitization",
    availableLanguages: ["python", "langchain", "curl", "nodejs"],
    defaultModelName: "document-parse",
  },
  ocr: {
    apiPath: "/api/ocr",
    playgroundPath: "/playground/ocr",
    documentationUrl:
      "https://console.upstage.ai/docs/capabilities/document-digitization/document-ocr",
    displayName: "OCR",
    showModel: true,
    showConfig: true,
    showConfidenceScore: true,
    apiUrl: "https://api.upstage.ai/v1/document-digitization",
    availableLanguages: ["python", "curl", "nodejs"],
    defaultModelName: "ocr",
  },
  extractor: {
    apiPath: "/api/extractor",
    playgroundPath: "/playground/kie",
    documentationUrl:
      "https://console.upstage.ai/docs/capabilities/information-extraction/prebuilt-information-extraction",
    displayName: "Extractor",
    showModel: true,
    showConfig: false,
    showConfidenceScore: true,
    apiUrl: "https://api.upstage.ai/v1/information-extraction",
    availableLanguages: ["python", "curl", "nodejs"],
    defaultModelName: "receipt-extraction",
  },
};

// 유틸리티 함수들
export const getApiPath = (type: EndpointType) =>
  ENDPOINT_CONFIGS[type]?.apiPath || "";
export const getPlaygroundPath = (type: EndpointType) =>
  ENDPOINT_CONFIGS[type]?.playgroundPath || "";
export const getDocumentationUrl = (type: EndpointType) =>
  ENDPOINT_CONFIGS[type]?.documentationUrl || "";
export const getDisplayName = (type: EndpointType) =>
  ENDPOINT_CONFIGS[type]?.displayName || "";
export const getShowModel = (type: EndpointType) =>
  !!ENDPOINT_CONFIGS[type]?.showModel;
export const getShowConfig = (type: EndpointType) =>
  !!ENDPOINT_CONFIGS[type]?.showConfig;
export const getShowConfidenceScore = (type: EndpointType) =>
  !!ENDPOINT_CONFIGS[type]?.showConfidenceScore;
